import { AWSTprmQuestionnaireApi } from 'Api/TPRM/AWSTprmQuestionnaireApi';
import { TprmQuestionnaireApi } from 'Api/TPRM/TprmQuestionnaireApi';
import { BasicAuthHandler, PublicDDQSession } from 'Helpers/Auth/BasicAuth/BasicAuthHandler';
import { LocalStorageStringRepository } from 'Helpers/LocalStorageStringRepository';
import { Navigator } from 'Helpers/Navigator';
import { StringRepository } from 'Helpers/StringRepository';
import { WindowNavigator } from 'Helpers/WindowNavigator';

export const PUBLIC_DDQ_BASE64_CREDS = 'public_ddq_base64_creds';

export class PublicDDQBasicAuthHandler implements BasicAuthHandler {
    questionnaireApi: TprmQuestionnaireApi;
    navigator: Navigator;
    stringRepository: StringRepository;

    constructor(questionnaireApi: TprmQuestionnaireApi = new AWSTprmQuestionnaireApi(), navigator: Navigator = new WindowNavigator(), stringRepository: StringRepository = new LocalStorageStringRepository()) {
        this.questionnaireApi = questionnaireApi;
        this.navigator = navigator;
        this.stringRepository = stringRepository;
    }

    login = async (username: string, password: string, client_id: string, third_party_id: string, service_id: string): Promise<void> => {
        const passwordAndIds = JSON.stringify({ password: password, client_id, third_party_id, service_id });
        const encodedCredentials = window.btoa(`${username}:${passwordAndIds}`);
        await this.questionnaireApi.checkIfAuthorized(encodedCredentials);
        this.stringRepository.setItem(PUBLIC_DDQ_BASE64_CREDS, encodedCredentials);
    };

    logout = (destination?: string): void => {
        if (this.getBase64EncodedCredentials() === null) {
            return;
        }

        this.stringRepository.removeItem(PUBLIC_DDQ_BASE64_CREDS);
        if (destination) {
            this.navigator.navigateTo(destination);
        }
    };

    getBase64EncodedCredentials = (): string | null => this.stringRepository.getItem(PUBLIC_DDQ_BASE64_CREDS);

    getAuthenticatedSession = (): PublicDDQSession | undefined => {
        const encodedCredentials = this.getBase64EncodedCredentials();
        if (!encodedCredentials) {
            return undefined;
        }

        try {
            const decodedCredentials = window.atob(encodedCredentials);
            const email_address = decodedCredentials.substring(0, decodedCredentials.indexOf(':'));
            const { client_id, third_party_id, service_id } = JSON.parse(decodedCredentials.substring(decodedCredentials.indexOf(':') + 1));
            if (!client_id || !third_party_id || !service_id) {
                return undefined;
            }
            return { client_id, email_address, service_id, third_party_id };
        } catch {
            return undefined;
        }
    };

    getAuthenticatedUserEmail = (): string | undefined => {
        const encodedCredentials = this.getBase64EncodedCredentials();
        if (encodedCredentials) {
            const decodedCredentials = window.atob(encodedCredentials);
            const [email] = decodedCredentials.split(':');
            return email;
        }
    };
}
